/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

export const GET_ALL_CARBON_INTENSITY_RESPONSE = {
	title: "Carbon Intensities regional Heatmap",
	mapRegions: [
		{
			name: "Italy",
			value: 999,
			unit: "kgCO2e/kWh",
			shortName: "ITA"
		},
		{
			name: "Czechia",
			value: 120,
			unit: "kgCO2e/kWh",
			shortName: "CZ"
		},
		{
			name: "Spain",
			value: 2004,
			unit: "kgCO2e/kWh",
			shortName: "ES"
		}
	]
};

export const GET_MONTHLY_AVERAGE_BY_REGION_RESPONSE = {
	annualCI: {
		label: "Annual CI",
		carbonIntensity: {
			value: 250.3,
			unit: "gCO2e/kWh"
		}
	},
	quarterCIs: [
		{
			label: "Jan-Mar",
			carbonIntensity: {
				value: 250,
				unit: "gCO2e/kWh"
			}
		},
		{
			label: "Apr-Jun",
			carbonIntensity: {
				value: 250,
				unit: "gCO2e/kWh"
			}
		},
		{
			label: "Jul-Sep",
			carbonIntensity: {
				value: 250,
				unit: "gCO2e/kWh"
			}
		},
		{
			label: "Oct-Dec",
			carbonIntensity: {
				value: 250,
				unit: "gCO2e/kWh"
			}
		}
	]
};

export const GET_HOURLY_AVERAGE_BY_REGION_RESPONSE = {
	title: "Hourly Data",
	lineSeries: [
		{
			name: "Data Points",
			linePoints: [
				{ name: "0:00", value: 40, unit: "units" },
				{ name: "4:00", value: 40, unit: "units" },
				{ name: "8:00", value: 38, unit: "units" },
				{ name: "12:00", value: 38, unit: "units" },
				{ name: "16:00", value: 38, unit: "units" },
				{ name: "20:00", value: 21, unit: "units" },
				{ name: "24:00", value: 37, unit: "units" }
			]
		}
	]
};
